import { render } from "./ModeratorGlobal.vue?vue&type=template&id=0ea5bbdb&scoped=true&ts=true"
import script from "./ModeratorGlobal.vue?vue&type=script&lang=ts"
export * from "./ModeratorGlobal.vue?vue&type=script&lang=ts"

import "./ModeratorGlobal.vue?vue&type=style&index=0&id=0ea5bbdb&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ea5bbdb"]])

export default __exports__